import axios from "axios";

export const getAgoraToken = (data) => {
  let url = "api/loginEndpoints/v1/rtcAgoraToken";
  return axios.post(url, data);
};
export const checkingProviderStatus = (url, passingOject) => {
  return axios.post(url, passingOject);
};
